import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

import { ViewportBreakpointConfig } from "./viewport-breakpoint.model";

@Injectable({
	providedIn: "root",
})
export class ViewportBreakpointConfigService {
	private viewportSizesConfig: ViewportBreakpointConfig = {
		small: 568,
		medium: 768,
		large: 1024,
		extraLarge: 1331,
	};

	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getViewportSizes(): ViewportBreakpointConfig {
		return this.configService.get(
			(x) => x.globalUi.viewportBreakpoint.defaults,
			this.viewportSizesConfig
		) as ViewportBreakpointConfig;
	}
}
